const Circle: React.FC<{ fill: string }> = ({ fill, ...rest }) => {
	return (
		<svg viewBox="0 0 100 100" {...rest}>
			<circle fill={fill} cx="50" cy="50" r="45" />
		</svg>
	);
};

export default Circle;
